<ng-container *ngIf="saseung3">
  <app-hanja-content [hanjas]="saseung3.hanja"
                     [hangul]="saseung3.hangul"
                     [firstHun]="firstHun"
                     ></app-hanja-content>

  <div class="con-box">
    <div class="row-box">
      <div class="first-line">
        <span *ngFor="let tone of getFourTonesArray()"
              class="label-txt">{{ GetSaseungTxt(tone) }}성</span>
        <span class="first-hun"
              [innerHTML]="firstHun | resize | keepHtml"></span>
        <b *ngIf="showHangul">&nbsp;{{ saseung3.hangul }}</b>
      </div>
      <div class="rest-hun"
           *ngIf="restHun"
           [innerHTML]="restHun | resize | keepHtml"></div>
    </div>
  </div>

  <div class="bookmark-box" *ngIf="showBookmark">
    <a class="bookmark-btn {{ getBmCss(saseung3) }}"
       (click)="ToggleBookmark($event, saseung3)"></a>
  </div>
</ng-container>
